import React, { forwardRef } from "react";
import { createPortal } from "react-dom";
import DatePicker from "react-datepicker";
import { CalendarDaysIcon } from "@heroicons/react/20/solid";
import "react-datepicker/dist/react-datepicker.css";
import "./DateTimePicker.css";

const TriggerButton = forwardRef(
  ({ value, onClick, placeholder, disabled, className }, ref) => (
    <button
      type="button"
      ref={ref}
      onClick={onClick}
      disabled={disabled}
      className={`${className} flex items-center justify-between gap-2 text-left`}
    >
      <span className={`whitespace-nowrap ${value ? "text-gray-900" : "text-gray-400"}`}>
        {value || placeholder}
      </span>
      <CalendarDaysIcon className="h-4 w-4 text-gray-400 shrink-0" />
    </button>
  )
);

// A date-only range picker (no time) used to filter lists by a date span.
// `startDate`/`endDate` are Date objects or null; `onChange(start, end)`
// fires on every click within the range, including the first click (which
// sets only `start`, leaving `end` null until the second click).
export function DateRangePicker({
  startDate,
  endDate,
  onChange,
  placeholder = "Select date range",
  className,
  disabled,
}) {
  return (
    <DatePicker
      selectsRange
      startDate={startDate}
      endDate={endDate}
      onChange={([start, end]) => onChange(start, end)}
      dateFormat="MMM d, yyyy"
      disabled={disabled}
      wrapperClassName="app-datepicker-wrapper"
      popperClassName="app-datepicker-popper app-datepicker-popper--no-time"
      // Rendered into document.body so the popup isn't clipped by the
      // scrollable, rounded card it lives in — see DateTimePicker.jsx.
      popperContainer={({ children }) => createPortal(children, document.body)}
      customInput={<TriggerButton placeholder={placeholder} className={className} />}
    />
  );
}
